__turbopack_context__.v({
  "active": "_1STAna_active",
  "bottomNav": "_1STAna_bottomNav",
  "bottomNavHidden": "_1STAna_bottomNavHidden",
  "closeButton": "_1STAna_closeButton",
  "fadeIn": "_1STAna_fadeIn",
  "languageSelector": "_1STAna_languageSelector",
  "menuBackdrop": "_1STAna_menuBackdrop",
  "menuDrawer": "_1STAna_menuDrawer",
  "menuHeader": "_1STAna_menuHeader",
  "menuItem": "_1STAna_menuItem",
  "menuItemActive": "_1STAna_menuItemActive",
  "menuSection": "_1STAna_menuSection",
  "menuSectionLabel": "_1STAna_menuSectionLabel",
  "navIcon": "_1STAna_navIcon",
  "navItem": "_1STAna_navItem",
  "navLabel": "_1STAna_navLabel",
  "navLogo": "_1STAna_navLogo",
  "navLogoImage": "_1STAna_navLogoImage",
  "signInButton": "_1STAna_signInButton",
  "signOutButton": "_1STAna_signOutButton",
  "slideUp": "_1STAna_slideUp",
  "userAvatar": "_1STAna_userAvatar",
  "userEmail": "_1STAna_userEmail",
  "userInfo": "_1STAna_userInfo",
});
